export default __webpack_public_path__ + "static/media/qr-mobile-app.19c8a049.png";